// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "action_item.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "action_item.proto" (syntax proto3)
// tslint:disable
import { DateRange } from "./common";
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class GeneratedTask$Type extends MessageType {
    constructor() {
        super("GeneratedTask", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "creator_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "date_viewed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "date_dismissed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "due_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "status_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "priority_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "priority", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "not_equals", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.userId = 0;
        message.creatorId = 0;
        message.dateCreated = "";
        message.dateViewed = "";
        message.dateDismissed = "";
        message.description = "";
        message.dueDate = "";
        message.isActive = false;
        message.fieldMask = [];
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        message.pageNumber = 0;
        message.statusId = 0;
        message.priorityId = 0;
        message.status = "";
        message.priority = "";
        message.notEquals = [];
        message.dateRange = [];
        message.dateTarget = [];
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* int32 creator_id */ 3:
                    message.creatorId = reader.int32();
                    break;
                case /* string date_created */ 4:
                    message.dateCreated = reader.string();
                    break;
                case /* string date_viewed */ 5:
                    message.dateViewed = reader.string();
                    break;
                case /* string date_dismissed */ 6:
                    message.dateDismissed = reader.string();
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                case /* string due_date */ 8:
                    message.dueDate = reader.string();
                    break;
                case /* bool is_active */ 9:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 10:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string order_by */ 11:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 12:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 13:
                    message.withoutLimit = reader.bool();
                    break;
                case /* int32 page_number */ 14:
                    message.pageNumber = reader.int32();
                    break;
                case /* int32 status_id */ 15:
                    message.statusId = reader.int32();
                    break;
                case /* int32 priority_id */ 16:
                    message.priorityId = reader.int32();
                    break;
                case /* string status */ 17:
                    message.status = reader.string();
                    break;
                case /* string priority */ 18:
                    message.priority = reader.string();
                    break;
                case /* repeated string not_equals */ 19:
                    message.notEquals.push(reader.string());
                    break;
                case /* repeated string date_range */ 20:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 21:
                    message.dateTarget.push(reader.string());
                    break;
                case /* string name */ 22:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* int32 creator_id = 3; */
        if (message.creatorId !== 0)
            writer.tag(3, WireType.Varint).int32(message.creatorId);
        /* string date_created = 4; */
        if (message.dateCreated !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dateCreated);
        /* string date_viewed = 5; */
        if (message.dateViewed !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dateViewed);
        /* string date_dismissed = 6; */
        if (message.dateDismissed !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.dateDismissed);
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        /* string due_date = 8; */
        if (message.dueDate !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.dueDate);
        /* bool is_active = 9; */
        if (message.isActive !== false)
            writer.tag(9, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 10; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string order_by = 11; */
        if (message.orderBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 12; */
        if (message.orderDir !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 13; */
        if (message.withoutLimit !== false)
            writer.tag(13, WireType.Varint).bool(message.withoutLimit);
        /* int32 page_number = 14; */
        if (message.pageNumber !== 0)
            writer.tag(14, WireType.Varint).int32(message.pageNumber);
        /* int32 status_id = 15; */
        if (message.statusId !== 0)
            writer.tag(15, WireType.Varint).int32(message.statusId);
        /* int32 priority_id = 16; */
        if (message.priorityId !== 0)
            writer.tag(16, WireType.Varint).int32(message.priorityId);
        /* string status = 17; */
        if (message.status !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.status);
        /* string priority = 18; */
        if (message.priority !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.priority);
        /* repeated string not_equals = 19; */
        for (let i = 0; i < message.notEquals.length; i++)
            writer.tag(19, WireType.LengthDelimited).string(message.notEquals[i]);
        /* repeated string date_range = 20; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(20, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 21; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(21, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* string name = 22; */
        if (message.name !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GeneratedTask
 */
export const GeneratedTask = new GeneratedTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneratedTaskList$Type extends MessageType {
    constructor() {
        super("GeneratedTaskList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GeneratedTask },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated GeneratedTask results */ 1:
                    message.results.push(GeneratedTask.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated GeneratedTask results = 1; */
        for (let i = 0; i < message.results.length; i++)
            GeneratedTask.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GeneratedTaskList
 */
export const GeneratedTaskList = new GeneratedTaskList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImpliedTask$Type extends MessageType {
    constructor() {
        super("ImpliedTask", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "quantity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.name = "";
        message.quantity = 0;
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int32 quantity */ 3:
                    message.quantity = reader.int32();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int32 quantity = 3; */
        if (message.quantity !== 0)
            writer.tag(3, WireType.Varint).int32(message.quantity);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ImpliedTask
 */
export const ImpliedTask = new ImpliedTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImpliedTaskList$Type extends MessageType {
    constructor() {
        super("ImpliedTaskList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ImpliedTask },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ImpliedTask results */ 1:
                    message.results.push(ImpliedTask.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ImpliedTask results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ImpliedTask.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ImpliedTaskList
 */
export const ImpliedTaskList = new ImpliedTaskList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneratedTaskDocument$Type extends MessageType {
    constructor() {
        super("GeneratedTaskDocument", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "generated_task_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "file_bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "file_mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "not_equals", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.generatedTaskId = 0;
        message.fileId = 0;
        message.url = "";
        message.description = "";
        message.dateCreated = "";
        message.isActive = false;
        message.fileName = "";
        message.fileBucket = "";
        message.fileMimeType = "";
        message.fieldMask = [];
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        message.pageNumber = 0;
        message.notEquals = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 generated_task_id */ 2:
                    message.generatedTaskId = reader.int32();
                    break;
                case /* int32 file_id */ 3:
                    message.fileId = reader.int32();
                    break;
                case /* string url */ 4:
                    message.url = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string date_created */ 6:
                    message.dateCreated = reader.string();
                    break;
                case /* bool is_active */ 7:
                    message.isActive = reader.bool();
                    break;
                case /* string file_name */ 8:
                    message.fileName = reader.string();
                    break;
                case /* string file_bucket */ 9:
                    message.fileBucket = reader.string();
                    break;
                case /* string file_mime_type */ 10:
                    message.fileMimeType = reader.string();
                    break;
                case /* repeated string field_mask */ 11:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string order_by */ 12:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 13:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 14:
                    message.withoutLimit = reader.bool();
                    break;
                case /* int32 page_number */ 15:
                    message.pageNumber = reader.int32();
                    break;
                case /* repeated string not_equals */ 16:
                    message.notEquals.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 generated_task_id = 2; */
        if (message.generatedTaskId !== 0)
            writer.tag(2, WireType.Varint).int32(message.generatedTaskId);
        /* int32 file_id = 3; */
        if (message.fileId !== 0)
            writer.tag(3, WireType.Varint).int32(message.fileId);
        /* string url = 4; */
        if (message.url !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.url);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string date_created = 6; */
        if (message.dateCreated !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.dateCreated);
        /* bool is_active = 7; */
        if (message.isActive !== false)
            writer.tag(7, WireType.Varint).bool(message.isActive);
        /* string file_name = 8; */
        if (message.fileName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.fileName);
        /* string file_bucket = 9; */
        if (message.fileBucket !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.fileBucket);
        /* string file_mime_type = 10; */
        if (message.fileMimeType !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.fileMimeType);
        /* repeated string field_mask = 11; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string order_by = 12; */
        if (message.orderBy !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 13; */
        if (message.orderDir !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 14; */
        if (message.withoutLimit !== false)
            writer.tag(14, WireType.Varint).bool(message.withoutLimit);
        /* int32 page_number = 15; */
        if (message.pageNumber !== 0)
            writer.tag(15, WireType.Varint).int32(message.pageNumber);
        /* repeated string not_equals = 16; */
        for (let i = 0; i < message.notEquals.length; i++)
            writer.tag(16, WireType.LengthDelimited).string(message.notEquals[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GeneratedTaskDocument
 */
export const GeneratedTaskDocument = new GeneratedTaskDocument$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneratedTaskDocumentList$Type extends MessageType {
    constructor() {
        super("GeneratedTaskDocumentList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GeneratedTaskDocument },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated GeneratedTaskDocument results */ 1:
                    message.results.push(GeneratedTaskDocument.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated GeneratedTaskDocument results = 1; */
        for (let i = 0; i < message.results.length; i++)
            GeneratedTaskDocument.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GeneratedTaskDocumentList
 */
export const GeneratedTaskDocumentList = new GeneratedTaskDocumentList$Type();
/**
 * @generated ServiceType for protobuf service ActionItem
 */
export const ActionItem = new ServiceType("ActionItem", [
    { name: "CreateGeneratedTask", options: {}, I: GeneratedTask, O: GeneratedTask },
    { name: "GetGeneratedTask", options: {}, I: GeneratedTask, O: GeneratedTask },
    { name: "BatchGetGeneratedTask", options: {}, I: GeneratedTask, O: GeneratedTaskList },
    { name: "UpdateGeneratedTask", options: {}, I: GeneratedTask, O: GeneratedTask },
    { name: "DeleteGeneratedTask", options: {}, I: GeneratedTask, O: Empty },
    { name: "BatchGetImpliedTask", options: {}, I: DateRange, O: ImpliedTaskList },
    { name: "CreateGeneratedTaskDocument", options: {}, I: GeneratedTaskDocument, O: GeneratedTaskDocument },
    { name: "GetGeneratedTaskDocument", options: {}, I: GeneratedTaskDocument, O: GeneratedTaskDocument },
    { name: "BatchGetGeneratedTaskDocument", options: {}, I: GeneratedTaskDocument, O: GeneratedTaskDocumentList },
    { name: "UpdateGeneratedTaskDocument", options: {}, I: GeneratedTaskDocument, O: GeneratedTaskDocument },
    { name: "DeleteGeneratedTaskDocument", options: {}, I: GeneratedTaskDocument, O: Empty }
]);
